import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    titleGeneral: {
        id: 'modal.cards.settings.title_general',
        defaultMessage: 'Settings',
    },
    titlePinConfirm: {
        id: 'modal.cards.settings.pin_confirm',
        defaultMessage: 'Confirmation',
    },
})
